import { useEffect, useState } from 'react';
import he from 'date-fns/locale/he';
import pt from 'date-fns/locale/pt';
import es from 'date-fns/locale/es';
import en from 'date-fns/locale/en-US';
import { useSelector } from 'react-redux';

import { AppState } from 'models/app-store';
import { LanguagesCodes } from 'utils/enums/language';

const useLocaleState = (): [state: Locale] => {
  const [localeState, setLocalState] = useState<Locale>(en); // Default to English

  const language = useSelector((state: AppState) => state.ui.language);

  useEffect(() => {
    // Add a language here
    const fetchLocale = async () => {
      switch (language) {
        case LanguagesCodes.He:
          setLocalState(he);

          break;
        case LanguagesCodes.Pr:
          setLocalState(pt);

          break;
        case LanguagesCodes.Es:
          setLocalState(es);

          break;
        default:
          setLocalState(en);
      }
    };

    fetchLocale();
  }, [language]);

  return [localeState];
};

export default useLocaleState;
